import * as Yup from "yup";
import { FormGroup } from "../../../components/form/models/models";
import { countries } from "../../utils/countries";
import { languages } from "../../utils/languages";

export const childForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      fieldType: "value",
      key: "isInternal",
      calculatedValue: () => true,
    },
    {
      type: "field",
      key: "firstName",
      fieldType: "input",
      label: "Child's given name",
      props: {
        disabled: true,
      },
      validation: Yup.string().trim().required("A response is required"), // Basic required validation
    },
    {
      type: "field",
      key: "lastName",
      fieldType: "input",
      label: "Child's family name",
      props: {
        disabled: true,
      },
    },
    {
      type: "field",
      key: "dateOfBirth",
      fieldType: "calendar",
      label: "Child's date of birth",
      props: {
        disabled: true,
      },
      validation: Yup.date().required("A response is required").max(new Date(), "Date may not be a future date"),
    },
    {
      type: "field",
      key: "gender",
      fieldType: "dropdown",
      label: "Gender",
      props: {
        disabled: true,
        appendTo: "self",
        placeholder: "Select a Gender",
        options: [
          {
            label: "Female",
            value: 1,
          },
          {
            label: "Male",
            value: 2,
          },
          {
            label: "Other",
            value: 3,
          },
          {
            label: "Not Provided",
            value: 4,
          },
        ],
      },
      validation: Yup.string().trim().required("A response is required"),
    },

    {
      type: "field",
      key: "suburb",
      fieldType: "input",
      label: "Suburb of residence",
      validation: Yup.string().trim().required("A response is required"),
    },

    {
      type: "field",
      key: "postcode",
      fieldType: "input",
      label: "Postcode of residence",
      validation: Yup.string()
        .trim()
        .required("A response is required")
        .test("postcode", "Please enter a valid postcode", (value) => {
          return /^[235]\d{3}$/.test(value ?? "");
        }),
    },
    {
      type: "field",
      fieldType: "radio",
      key: "placeOfBirth",
      label: "In which country was the child born?",
      validation: Yup.string().trim().required("A response is required"),
      props: {
        options: [
          {
            label: "Australia",
            value: 1,
          },
          {
            label: "Other",
            value: 2,
          },
        ],
      },
    },
    {
      type: "field",
      key: "otherPlaceOfBirth",
      fieldType: "dropdown",
      label: "Please select the country",
      validation: Yup.string().trim().required("A response is required"),
      hideExpression: (formContext, values, model) => model.placeOfBirth != 2,
      props: {
        options: countries,
      },
    },
    {
      type: "field",
      fieldType: "radio",
      key: "isMultiLingual",
      label: "Does the child speak a language other than English at home?",
      validation: Yup.string().trim().required("A response is required"),
      props: {
        options: [
          {
            label: "Yes",
            value: 1,
          },
          {
            label: "No",
            value: 0,
          },
        ],
      },
    },
    {
      type: "field",
      key: "otherLanguage",
      fieldType: "dropdown",
      label: "Please select the language",
      hideExpression: (formContext, values, model) => model.isMultiLingual != 1,
      validation: Yup.string().trim().required("A response is required"),
      props: {
        options: languages,
      },
    },
    {
      type: "field",
      key: "isIndigenousAustralian",
      fieldType: "radio",
      label: "Is the child of Australian Aboriginal or Torres Strait Islander origin?",
      validation: Yup.string().required("An option must be selected"),
      props: {
        options: [
          {
            label: "Yes - Aboriginal",
            value: 1,
          },
          {
            label: "Yes - Torres Strait Islander",
            value: 2,
          },
          {
            label: "Yes - Aboriginal and Torres Strait Islander",
            value: 3,
          },
          {
            label: "No, neither Aboriginal nor Torres Strait Islander",
            value: 0,
          },
        ],
      },
    },
    {
      type: "field",
      key: "otherPrePrepPriorityCohorts",
      fieldType: "radio",
      label: "Is the child in any of the other pre-prep priority cohorts?",
      warn: (
        <span className="text-primary">
          Please refer to{" "}
          <a className="underline " href="https://www.vic.gov.au/delivering-pre-prep-children-priority-cohorts" target="_blank" rel="noreferrer">
            Delivering Pre-Prep to children from priority cohorts | vic.gov.au for more information about the priority cohorts.
            <i className="pi pi-external-link ml-1"></i>{" "}
          </a>
        </span>
      ),
      warnType: "information",
      validation: Yup.string().required("An option must be selected"),
      props: {
        options: [
          {
            label: "Yes",
            value: 1,
          },
          {
            label: "No",
            value: 0,
          },
        ],
      },
    },
  ],
};
